// extracted by mini-css-extract-plugin
export default {"container":"detail_container__NwUXy","table":"detail_table__Qw2-O"};